import React from 'react';
import { Form } from 'src/components/shared';
import LoginForm from '../components/LoginForm';
import { Typography } from '@mui/material';
import Spacer from 'src/components/shared/Spacer';
import theme from 'src/config/theme';

function LoginContainer() {
  return (
    <>
      <Spacer x={2} y={2} />
      <LoginForm />
      <Spacer x={2} y={2} />
    </>
  );
}

export default LoginContainer;
